import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { hasActiveSession } from "../utils/authStorage";

export default function WelcomePage() {
  const navigate = useNavigate();
  const [showGuestPrompt, setShowGuestPrompt] = useState(false);

  const handleStartWorkspace = () => {
    if (!hasActiveSession()) {
      setShowGuestPrompt(true);
      return;
    }
    navigate("/home");
  };

  return (
    <div className="welcome-shell">
      <div className="welcome-card">
        <div className="welcome-brand">
          <span className="welcome-logo">EcoTrack 2.0</span>
          <span className="welcome-pill">
            <span aria-hidden="true">🌏</span>
            India Biodiversity Intelligence Platform
          </span>
        </div>
        <h1>Field-ready intelligence for biodiversity teams.</h1>
        <p>
          Track sightings, validate reports, and coordinate conservation responses with a unified,
          mobile-first workspace.
        </p>
        <div className="welcome-actions">
          <button className="eco-btn" onClick={handleStartWorkspace}>
            Start Workspace
          </button>
          <button className="eco-btn outline" onClick={() => navigate("/user-login")}>
            Continue to Login
          </button>
        </div>
        <div className="welcome-meta">
          <div>
            <h4>Live field reporting</h4>
            <span>Camera, GPS, and on-site notes.</span>
          </div>
          <div>
            <h4>DSS + AI insights</h4>
            <span>Prioritize hotspots instantly.</span>
          </div>
          <div>
            <h4>Admin oversight</h4>
            <span>Manage datasets and validation.</span>
          </div>
        </div>
      </div>

      {showGuestPrompt ? (
        <div className="eco-modal-overlay" role="presentation">
          <div className="eco-modal" role="dialog" aria-modal="true" aria-label="Guest mode notice">
            <h3>Limited Guest Access</h3>
            <p>
              You can browse home, species, map, and awareness in guest mode. Login is required for
              DSS, report submission, and admin pages.
            </p>
            <div className="eco-modal-actions">
              <button
                type="button"
                className="eco-btn outline"
                onClick={() => {
                  setShowGuestPrompt(false);
                  navigate("/user-login");
                }}
              >
                Login Now
              </button>
              <button
                type="button"
                className="eco-btn"
                onClick={() => {
                  setShowGuestPrompt(false);
                  navigate("/home");
                }}
              >
                Continue as Guest
              </button>
            </div>
            <button
              type="button"
              className="eco-modal-close"
              onClick={() => setShowGuestPrompt(false)}
            >
              Close
            </button>
          </div>
        </div>
      ) : null}
    </div>
  );
}
